import React, { useEffect, useState } from 'react'
import { X, Download, ZoomIn, ZoomOut, ImageOff, ExternalLink } from 'lucide-react'
import { downloadFile, normalizeUploadUrl, openExternal } from '../lib/openExternal'

// Ảnh bài đã chấm (GV ghi chú) — XEM & TẢI ngay trên web: bấm để phóng to (lightbox có zoom),
// nút "Tải ảnh" fetch blob rồi lưu. KHÔNG điều hướng tới URL file (tránh app chiếm link → 404).
const AnnotatedImage: React.FC<{ url: string; alt?: string; thumbClass?: string; downloadName?: string }>
  = ({ url, alt, thumbClass, downloadName }) => {
  const safeUrl = normalizeUploadUrl(url)
  const [open, setOpen] = useState(false)
  const [zoom, setZoom] = useState(1)
  const [failed, setFailed] = useState(false)

  useEffect(() => { setFailed(false) }, [safeUrl])

  if (failed) {
    return (
      <div className={(thumbClass || 'rounded-lg border border-amber-200') + ' flex items-center justify-between gap-3 bg-amber-50/70 p-3 text-sm text-amber-900'}>
        <div className="flex min-w-0 items-center gap-2">
          <ImageOff size={18} className="shrink-0" />
          <span className="truncate font-semibold">Không tải được ảnh đã chấm</span>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button type="button" onClick={() => downloadFile(safeUrl, downloadName)} className="inline-flex items-center gap-1 rounded-lg border border-amber-300 bg-white px-2.5 py-1 font-bold hover:bg-amber-100"><Download size={14} /> Tải</button>
          <button type="button" onClick={() => openExternal(safeUrl)} className="inline-flex items-center gap-1 rounded-lg border border-amber-300 bg-white px-2.5 py-1 font-bold hover:bg-amber-100"><ExternalLink size={14} /> Mở</button>
        </div>
      </div>
    )
  }

  return (
    <>
      <img
        src={safeUrl} alt={alt || 'Ảnh đã chấm'} loading="lazy"
        onError={() => setFailed(true)}
        onClick={() => { setOpen(true); setZoom(1) }}
        className={(thumbClass || 'rounded-lg border border-amber-200') + ' cursor-zoom-in hover:ring-2 hover:ring-amber-300'}
      />
      {open && (
        <div className="fixed inset-0 z-[350] bg-black/80 flex flex-col" onClick={() => setOpen(false)}>
          <div className="flex items-center gap-2 p-3 text-white" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setZoom((z) => Math.max(0.5, +(z - 0.25).toFixed(2)))} title="Thu nhỏ" className="p-1.5 rounded hover:bg-white/10"><ZoomOut size={20} /></button>
            <span className="text-sm w-12 text-center tabular-nums">{Math.round(zoom * 100)}%</span>
            <button onClick={() => setZoom((z) => Math.min(5, +(z + 0.25).toFixed(2)))} title="Phóng to" className="p-1.5 rounded hover:bg-white/10"><ZoomIn size={20} /></button>
            <button onClick={() => downloadFile(safeUrl, downloadName)} className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/15 hover:bg-white/25 text-sm font-bold"><Download size={16} /> Tải ảnh</button>
            <button onClick={() => setOpen(false)} title="Đóng" className="p-1.5 rounded hover:bg-white/10"><X size={22} /></button>
          </div>
          <div className="flex-1 overflow-auto p-4 text-center" onClick={(e) => e.stopPropagation()}>
            <img src={safeUrl} alt={alt || 'Ảnh đã chấm'} onError={() => setFailed(true)} style={{ width: `${zoom * 100}%`, maxWidth: 'none' }} className="inline-block rounded shadow-2xl bg-white align-top" />
          </div>
        </div>
      )}
    </>
  )
}

export default AnnotatedImage
